import { authHeader } from '@/_helpers';
import { store } from '../_store';
export const billingsService = {
    getBillingProfile,
    saveBillingProfile,
    getTransactions,
    getSummary,
    getPaymentMethods,
    getPaymentMethod,
    getInvoices,
    saveSepaPaymentMethod,
    deletePaymentMethod,
    confirmPaymentMethod,
    getPendingPayments,
    downloadPDF,
    getUsages,
    lastPayment,
    chargePendingPayments,
    getDashboard,
    getStats,
    getObjetives,
    getCredits,
    getTotalCredits,
    getCommissionDetail,
    updateComment,
    deleteCreditToClient,
    createInvoiceClient,
    getAllClientPaymentMethods,
    downloadMandatSepa,
    downloadInvoice,
    getRecoveryActions,
    createRecoveryAction,
    getRecoveryNotes,
    createRecoveryNote,
    updateRecoveryStatus,
    updateRecoveryInvoiceStatus,
    changePaymentStatus,
    getTotalCreditsByClient,
};

const apiUrl = process.env.VUE_APP_ROOT_API;


function getBillingProfile(user_id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/payments/payment-profile/${user_id}`, requestOptions).then(handleResponse);
}

function saveBillingProfile(billingProfile) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify(billingProfile)
    };

    return fetch(`${apiUrl}/payments/payment-profile`, requestOptions).then(handleResponse);
}

function getTransactions() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/payments/transactions`, requestOptions).then(handleResponse);
}

function getSummary() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/payments/summary`, requestOptions).then(handleResponse);
}

function getPaymentMethods() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/payments/payment-methods`, requestOptions).then(handleResponse);
}

function getInvoices(cantPerPage, currentPage, payment_status_id, getTotal, filters, onlyViewRecovering = false) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ cantPerPage, currentPage, payment_status_id, getTotal, filters, onlyViewRecovering })
    };
    return fetch(`${apiUrl}/payments/invoices`, requestOptions).then(handleResponse);
}

function updateComment(payload) {
    console.log('Updating comment with payload:', payload);
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify(payload)
    };
    return fetch(`${apiUrl}/payments/update-comment`, requestOptions).then(handleResponse);
}

function saveSepaPaymentMethod(paymentMethod) {


    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify(paymentMethod)
    };

    // window.dataLayer.push({
    //     'event': 'Paiement_Enregistre_Front',
    //     'user_Mail': store.state.authentication.user.email, 											// Si vide valoriser par ""
    //     'user_Phone':store.state.authentication.user.phone,  											// Si vide valoriser par ""
    //     });

    return fetch(`${apiUrl}/payments/payment-method`, requestOptions).then(handleResponse);
}

function getPaymentMethod(id, paymentType) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/payments/payment-method/${paymentType}/${id}`, requestOptions).then(handleResponse);
}

function deletePaymentMethod(paymentMethodId, paymentType) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({id: paymentMethodId, payment_type : paymentType})
    };

    return fetch(`${apiUrl}/payments/payment-method/delete`, requestOptions).then(handleResponse);
}

function confirmPaymentMethod(ingenicoResponse) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify(ingenicoResponse)
    };

    return fetch(`${apiUrl}/payments/payment-method/confirmed`, requestOptions).then(handleResponse);
}

function getPendingPayments() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/payments/pendings`, requestOptions).then(handleResponse);
}

function downloadPDF(paymentId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/billings/download?id=${paymentId}`, requestOptions).then(handleResponse);
}

function getUsages(currentPage, cantPerPage, initDateFilter, endDateFilter, productFilter, companyNameFilter, companyIdFilter) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/payments/usages?currentPage=${currentPage}&cantPerPage=${cantPerPage}&initDateFilter=${initDateFilter}&endDateFilter=${endDateFilter}&productFilter=${productFilter}&companyNameFilter=${companyNameFilter}&companyIdFilter=${companyIdFilter}`, requestOptions).then(handleResponse);
}

function lastPayment() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/payments/last-payment`, requestOptions).then(handleResponse);
}

function chargePendingPayments(generate_payment) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({generate_payment: generate_payment})

    };
    return fetch(`${apiUrl}/payments/charge-pendings`, requestOptions).then(handleResponse);
}

function getDashboard(user_id, target_id = 0) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({user_id, target_id})
    };
    return fetch(`${apiUrl}/billings/dashboard`, requestOptions).then(handleResponse);
}

function getCommissionDetail(user_id, target_id = 0, year = 0, fake = 0) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({user_id, target_id, year, fake})
    };
    return fetch(`${apiUrl}/billings/booker-commision-detail`, requestOptions).then(handleResponse);
}



function getCredits(params) {
  const cleanParams = Object.fromEntries(
    Object.entries(params || {}).filter(([_, v]) => v !== null && v !== undefined)
  );

  const queryString = new URLSearchParams(cleanParams).toString();

  const requestOptions = {
      method: 'GET',
      headers: authHeader('application/json')
  };
  return fetch(`${apiUrl}/billings/get-credits?${queryString}`, requestOptions).then(handleResponse);
}

function getTotalCredits(params) {

    const cleanParams = Object.fromEntries(
        Object.entries(params).filter(([_, v]) => v !== null && v !== undefined)
      );

    const queryString = new URLSearchParams(cleanParams).toString();

    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/billings/get-total-credits?${queryString}`, requestOptions).then(handleResponse);
  }

function getStats() {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/billings/get-stats`, requestOptions).then(handleResponse);
}

function getObjetives() {
  const requestOptions = {
      method: 'GET',
      headers: authHeader('application/json')
  };
  return fetch(`${apiUrl}/billings/get-objective`, requestOptions).then(handleResponse);
}

function deleteCreditToClient(id){
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({id})
    };
    return fetch(`${apiUrl}/billings/delete-credit`, requestOptions).then(handleResponse);
}

function createInvoiceClient(comment, amount, client_id){
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({comment, amount, client_id})
    };
    return fetch(`${apiUrl}/payments/payment/new`, requestOptions).then(handleResponse);
}

function getAllClientPaymentMethods(filters){
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify(filters)
    };
    return fetch(`${apiUrl}/payments/get-all-payment-methods`, requestOptions).then(handleResponse);
}

function downloadMandatSepa(id){
   const requestOptions = {
      method: 'GET',
      headers: authHeader('application/json')
  };
  return fetch(`${apiUrl}/billings/get-mandat-sepa/${id}`, requestOptions).then(handleBlobDownloadResponse);
}

function downloadInvoice(id) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json')
    };
    return fetch(`${apiUrl}/billings/get-invoice?id=${id}`, requestOptions).then(handleBlobDownloadResponse);
}

function getRecoveryActions(clientId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/payments/recovery-actions?client_id=${clientId}`, requestOptions).then(handleResponse);
}

function createRecoveryAction(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify(payload),
    };
    return fetch(`${apiUrl}/payments/recovery-actions`, requestOptions).then(handleResponse);
}

function updateRecoveryStatus(payload) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify(payload),
    };
    return fetch(`${apiUrl}/payments/recovery-status`, requestOptions).then(handleResponse);
}

function updateRecoveryInvoiceStatus(id, recovery_invoice_status_id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ id, recovery_invoice_status_id }),
    };
    return fetch(`${apiUrl}/payments/recovery-invoice-status`, requestOptions).then(handleResponse);
}

function changePaymentStatus(id, payment_status_id) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ id, payment_status_id }),
    };
    return fetch(`${apiUrl}/payments/change-status`, requestOptions).then(handleResponse);
}

function getRecoveryNotes(clientId) {
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/recovery-notes/?client_id=${clientId}`, requestOptions).then(handleResponse);
}

function createRecoveryNote(clientId, message) {
    const requestOptions = {
        method: 'POST',
        headers: authHeader('application/json'),
        body: JSON.stringify({ client_id: clientId, message }),
    };
    return fetch(`${apiUrl}/recovery-notes/`, requestOptions).then(handleResponse);
}

function getTotalCreditsByClient(client_id, amount){
    const requestOptions = {
        method: 'GET',
        headers: authHeader('application/json'),
    };
    return fetch(`${apiUrl}/billings/get-total-credits-in-month/${client_id}/${amount}`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            const error = data || response.statusText;
            return Promise.reject(error);
        }
        return data;
    });
}

function filenameFromContentDisposition(header) {
    if (!header) return null;
  
    // filename*=UTF-8''nombre.pdf (RFC 5987)
    const utf8Match = header.match(/filename\*=UTF-8''([^;\n]+)/i);
    if (utf8Match) {
      try {
        return decodeURIComponent(utf8Match[1].trim());
      } catch (e) {
        return utf8Match[1].trim();
      }
    }
  
    // filename="contract-ABC.pdf"
    const quotedMatch = header.match(/filename="([^"]+)"/i);
    if (quotedMatch) return quotedMatch[1];
  
    // filename=contract-ABC.pdf
    const unquotedMatch = header.match(/filename=([^;\n]+)/i);
    if (unquotedMatch) {
      return unquotedMatch[1].trim().replace(/^"|"$/g, '');
    }
  
    return null;
}

/** For endpoints that return raw PDF bytes (not JSON). */
function handleBlobDownloadResponse(response) {
    if (!response.ok) {
        return response.text().then((text) => {
            let error = response.statusText;
            try {
                const parsed = text && JSON.parse(text);
                error =
                    typeof parsed === 'string'
                        ? parsed
                        : (parsed && parsed.message) || (parsed && parsed.error) || error;
            } catch (e) {
                if (text) {
                    error = text.slice(0, 200);
                }
            }
            return Promise.reject(error);
        });
    }
    const filename = filenameFromContentDisposition(
        response.headers.get('Content-Disposition'),
    );
    return response.blob().then((blob) => ({ blob, filename }));
}
